import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { SecondaryIndustry } from '../../models/stack9/SecondaryIndustry';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type SecondaryIndustryDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<SecondaryIndustry>;
};

export const SecondaryIndustryDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: SecondaryIndustryDrawerProps) => {
  const formFields = [
    { field: 'code' },
    { field: 'name' },
    { field: 'is_active' },
    { field: 'lang_set' },
  ];

  return (
    <EntityDrawer
      title="secondary industry"
      formFields={formFields}
      initialValues={initialValues}
      id={id}
      open={open}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetSecondaryIndustryDetails}
      entityName={entityNames.SECONDARY_INDUSTRY}
      editRoute={AppRoutes.CountrySetupDetail}
      relativePath={AppRoutes.CountrySetupDetail}
    />
  );
};
